import { useCallback, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';

import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useClickOutside from './useClickOutside';
import MDBox from 'components/MDBox';

function PopoverPicker({ initialColor = 'white', onColorChange }) {
  const popover = useRef();
  const { formatMessage: msg } = useIntl();

  const [isOpen, toggle] = useState(false);
  const [color, setColor] = useState(initialColor || '#f2f2f2');

  const close = useCallback(() => {
    toggle(false);
  }, []);
  useClickOutside(popover, close);

  const handleOnColorChange = (value) => {
    setColor(value);
    onColorChange(value);
  };

  return (
    <MDBox>
      <IconButton
        aria-label={msg({ id: 'common.color.picker' })}
        sx={({ borders: { borderWidth }, transitions }) => ({
          width: '24px',
          height: '24px',
          padding: 0,
          border: `${borderWidth[1]} solid`,
          borderColor: 'white',
          transition: transitions.create('border-color', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.shorter
          }),
          backgroundColor: color,
          '&:hover, &:focus, &:active': {
            borderColor: 'white',
            backgroundColor: color
          }
        })}
        onClick={() => toggle(true)}
      />

      {isOpen && (
        <MDBox ref={popover} sx={{ position: 'absolute', zIndex: 1000 }} shadow>
          <HexColorPicker color={color} onChange={handleOnColorChange} sx={{ boxShadow: 3 }} />
        </MDBox>
      )}
    </MDBox>
  );
}

// Typechecking props for the DashboardNavbar
PopoverPicker.propTypes = {
  initialColor: PropTypes.string,
  onColorChange: PropTypes.func
};

export default PopoverPicker;
